<template>
  <v-dialog v-model="show">
    <v-card class="mt-2">
      <v-card-title primary-title>
        <span class="headline mb-0">通関業者追加</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="save">{{$t('app.buttons.save')}}</v-btn>
        <v-btn @click="back">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                return-object
                url="divisions/kv"
                v-model="query.bu"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="海外取引先"
                return-object
                url="companies/kv?type=PARTNER"
                v-model="query.partner"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                clearable
                return-object
                url="ports/kv"
                v-model="query.port"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['companyId'],
  data() {
    return {
      query: {},
      show: false,
      buUrl: `divisions/kv?type=BU&companyId=${this.companyId}`
    }
  },
  methods: {
    popup() {
      this.show = true
    },
    save() {
      this.$emit('create', this.query)
      this.show = false
    },
    back() {
      this.query = {}
      this.show = false
    }
  }
}
</script>
